/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} History_Transfer_Pick_HelperInputs */

const en_us2_history_transfer_pick_helper = /** @type {(inputs: History_Transfer_Pick_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Strong: Settings → Export data. In Hevy: Profile → Settings → Export & import data → Export workouts. Then choose the file here.`)
};

const pt_br2_history_transfer_pick_helper = /** @type {(inputs: History_Transfer_Pick_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Strong: Configurações → Exportar dados. No Hevy: Perfil → Configurações → Exportar e importar dados → Exportar treinos. Depois escolha o arquivo aqui.`)
};

const es_419_history_transfer_pick_helper = /** @type {(inputs: History_Transfer_Pick_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Strong: Configuración → Exportar datos. En Hevy: Perfil → Configuración → Exportar e importar datos → Exportar entrenamientos. Luego elige el archivo aquí.`)
};

const pt_pt2_history_transfer_pick_helper = /** @type {(inputs: History_Transfer_Pick_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Strong: Definições → Exportar dados. No Hevy: Perfil → Definições → Exportar e importar dados → Exportar treinos. Depois escolhe o ficheiro aqui.`)
};

const fr_fr2_history_transfer_pick_helper = /** @type {(inputs: History_Transfer_Pick_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dans Strong : Paramètres → Exporter les données. Dans Hevy : Profil → Paramètres → Exporter et importer des données → Exporter les séances. Choisis ensuite le fichier ici.`)
};

const de_de2_history_transfer_pick_helper = /** @type {(inputs: History_Transfer_Pick_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Strong: Einstellungen → Daten exportieren. In Hevy: Profil → Einstellungen → Daten exportieren & importieren → Trainings exportieren. Wähl dann hier die Datei aus.`)
};

const it_it2_history_transfer_pick_helper = /** @type {(inputs: History_Transfer_Pick_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Strong: Impostazioni → Esporta dati. In Hevy: Profilo → Impostazioni → Esporta e importa dati → Esporta allenamenti. Poi scegli il file qui.`)
};

/**
* | output |
* | --- |
* | "In Strong: Settings → Export data. In Hevy: Profile → Settings → Export & import data → Export workouts. Then choose the file here." |
*
* @param {History_Transfer_Pick_HelperInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const history_transfer_pick_helper = /** @type {((inputs?: History_Transfer_Pick_HelperInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<History_Transfer_Pick_HelperInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_history_transfer_pick_helper(inputs)
	if (locale === "es-419") return es_419_history_transfer_pick_helper(inputs)
	if (locale === "pt-PT") return pt_pt2_history_transfer_pick_helper(inputs)
	if (locale === "fr-FR") return fr_fr2_history_transfer_pick_helper(inputs)
	if (locale === "de-DE") return de_de2_history_transfer_pick_helper(inputs)
	if (locale === "it-IT") return it_it2_history_transfer_pick_helper(inputs)
	return en_us2_history_transfer_pick_helper(inputs)
});
export { history_transfer_pick_helper as "history-transfer.pick_helper" }